import { getApiBaseUrl } from '../../../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

/**
 * @param {string} serie
 * @param {{ dataInicio?: string, dataFim?: string }} [period]
 * @returns {Promise<{ success: boolean, contract: object|null, lastService: object|null, production: Array }>}
 */
export async function fetchEquipmentConsult(serie, period = {}) {
  const token = localStorage.getItem('authToken');
  let url = `${API_BASE_URL}/api/equipment/consult?serie=${encodeURIComponent(serie)}`;
  if (period.dataInicio && period.dataFim) {
    url += `&dataInicio=${encodeURIComponent(period.dataInicio)}&dataFim=${encodeURIComponent(period.dataFim)}`;
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Erro ao consultar equipamento');
  }
  return response.json();
}

/**
 * @param {string} serie
 * @param {{ dataInicio: string, dataFim: string }} period
 */
export async function fetchEquipmentProduction(serie, period) {
  const data = await fetchEquipmentConsult(serie, period);
  return Array.isArray(data.production) ? data.production : [];
}
